/**
 * Footer class.
 */
export class Footer {

	#footerEl;

	#mainEl;

	/**
	 * Constructor
	 */
	constructor (){

		this.#footerEl = document.querySelector( '.p-footer' );

		if ( !this.#footerEl ) {

			return;

		}

		this.#mainEl = document.querySelector( 'main' );

		this.#init();

	}

	/**
	 * Initialize menu
	 *
	 * @return {void}
	 */
	#init (){

		this.#setFooterCtaHeight();

		document.addEventListener( 'DOMContentLoaded', () => {

			requestAnimationFrame( () => {

				this.#setFooterCtaHeight();

			} );

		} );

		window.addEventListener( 'resize', () => {

			this.#setFooterCtaHeight();

		} );

	}


	/**
	 * Set CTA in footer height
	 *
	 * @return {void}
	 */
	#setFooterCtaHeight = () => {

		const footerCta = this.#footerEl.querySelector( '.p-footer__cta' );

		if ( !footerCta || !this.#mainEl ) {

			return;

		}

		document.body.style.setProperty( '--footer-cta-height', `${footerCta.scrollHeight}px` );

	};

}
